var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _, { forEach, head, isArray, isDate, isElement, isEmpty, isFunction, isNumber, isObject, isString, isUndefined } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { cookie } from '@stratusjs/core/environment';
import 'angular';
import 'angular-sanitize';
import { Collection } from '../services/collection';
import { isJSON, safeUniqueId, getUrlParams, setUrlParams, } from '@stratusjs/core/misc';
Stratus.Modules.ngSanitize = true;
Stratus.Controllers.Generic = [
    '$scope',
    '$element',
    '$log',
    '$sce',
    '$parse',
    '$window',
    'Registry',
    ($scope, $element, $log, $sce, $parse, $window, R) => __awaiter(void 0, void 0, void 0, function* () {
        $scope.uid = safeUniqueId('controller_generic_');
        Stratus.Instances[$scope.uid] = $scope;
        yield R.fetch($element, $scope);
        $scope.ctrlParent = $scope.$parent;
        $scope.Stratus = Stratus;
        $scope._ = _;
        $scope.cookie = cookie;
        $scope.$window = $window;
        $scope.getUrlParams = getUrlParams;
        $scope.setUrlParams = setUrlParams;
        $scope.$log = $log;
        $scope.Math = Math;
        $scope.isArray = isArray;
        $scope.isDate = isDate;
        $scope.isDefined = (value) => !isUndefined(value);
        $scope.isElement = isElement;
        $scope.isFunction = isFunction;
        $scope.isNumber = isNumber;
        $scope.isObject = isObject;
        $scope.isString = isString;
        $scope.isUndefined = isUndefined;
        $scope.getHTML = $sce.trustAsHtml;
        $scope.getURL = $sce.trustAsResourceUrl;
        $scope.getAnchor = () => {
            const url = window.location.href;
            if (!url || !url.length) {
                return false;
            }
            const anchor = url.indexOf('#');
            if (anchor < 0) {
                return false;
            }
            if ((anchor + 1) >= url.length) {
                return false;
            }
            return url.substring(anchor + 1, url.length);
        };
        $scope.scrollToAnchor = (anchor, inUrl, delay) => {
            if (!anchor || isEmpty(anchor)) {
                $log.warn('anchor id not set!');
                return false;
            }
            if (isUndefined(inUrl)) {
                inUrl = false;
            }
            if (inUrl && anchor !== $scope.getAnchor()) {
                return false;
            }
            const el = $window.document.getElementById(anchor);
            if (!el) {
                $log.warn(`element not found: ${anchor}`);
                return false;
            }
            if (!delay) {
                el.scrollIntoView({ behavior: 'smooth' });
                return true;
            }
            return setTimeout(() => {
                $scope.scrollToAnchor(anchor, inUrl, --delay);
            }, 1);
        };
        if ($scope.data && isFunction($scope.data.on)) {
            $scope.data.on('change', () => $scope.$applyAsync());
        }
        if (!$scope.collection || !($scope.collection instanceof Collection)) {
            return;
        }
        const selected = {
            id: $element.attr('data-selected'),
            raw: $element.attr('data-raw')
        };
        if (!selected.id || !isString(selected.id)) {
            return;
        }
        if (isJSON(selected.id)) {
            selected.id = JSON.parse(selected.id);
            $scope.$watch('collection.models', (models) => {
                if ($scope.selected || $scope.selectedInit) {
                    return;
                }
                forEach(models, (model) => {
                    if (selected.id !== model.getIdentifier()) {
                        return;
                    }
                    $scope.selected = selected.raw ? model.data : model;
                    $scope.selectedInit = true;
                });
            });
        }
        else {
            selected.model = $parse(selected.id);
            selected.value = selected.model($scope.$parent);
            if (!isArray(selected.value)) {
                return;
            }
            selected.value = selected.value.filter((n) => n);
            if (selected.value.length) {
                return;
            }
            $scope.selected = head(selected.value);
        }
    })
];

//# sourceMappingURL=generic.js.map
